import { FullModal } from '@vestaboard/installables'
import { GetMessage } from '../pages/GetMessage'
import React from 'react'

interface IMessageModal {
  onClose: () => void
  messageId: string | null
  onUpdateTags?: (id: string, tags: string[]) => void
}

export const MessageModal = (props: IMessageModal) => {
  return !!props.messageId ? (
    <FullModal onClose={props.onClose}>
      <div
        style={{
          height: '100%',
          overflow: 'auto',
          backgroundColor: 'white',
          padding: '24px'
        }}>
        {props.messageId ? <GetMessage messageId={props.messageId} onUpdateTags={props.onUpdateTags} /> : <div />}
      </div>
    </FullModal>
  ) : null
}
